/* @ngInject */

export default ($rootScope, logger) => {
  var service = {
    eventEmit: eventEmit,
    eventReceive: eventReceive
  };
  return service;

  /**
   * Emit new Broadcast event.
   *
   * @param {Object} _event - Event name.
   * @param {Object} [_args] - Event arguments.
   */
  function eventEmit(_event, _args) {
    logger.debug('broadcastService', 'eventEmit', 'Emitting new event', _event, _args);
    $rootScope.$broadcast(_event, _args);
  }

  /**
   * Receive broadcasted event.
   *
   * @param {Object} _event - Event name.
   * @param {Function} _callback - Callback function.
   *
   * @returns {Function} - Event de-registration function.
   */
  function eventReceive(_event, _callback) {
    return $rootScope.$on(_event, function (event, args) {
      logger.debug('broadcastService', 'eventReceive', 'Received event', _event, args);
      if (_callback) {
        _callback(args);
      }
    });
  }
};
